export const LAST_VALUES = {};
